import { GuardStepResult } from "@/hooks/useGuardStep";
import { Step } from "@/types/flows";
import { useFlowState } from "@/hooks/useFlowState";

export type UseGuardStep = (expectedStep: Step) => GuardStepResult;

export const useGuardSetupStep: UseGuardStep = () => {
    const { step } = useFlowState();

    return { loading: false, step, passThrough: true, errors: [], redirect: null };
};
